import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

document.querySelectorAll('[data-slider]').forEach(slider => {

  const options = {
    modules: [Navigation],
    loop: false,
    autoHeight: false,
    allowTouchMove: true,
    navigation : {
      nextEl: slider.querySelector('.slider-next'),
      prevEl: slider.querySelector('.slider-prev'),
    },
    slidesPerView: 3,
    spaceBetween: 20,

    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
      1440: {
        slidesPerView: 'auto',
        spaceBetween: 30,
      },
    }
  };

  const swiper = new Swiper(slider.querySelector('.swiper'), options);



})
